import React, { Fragment, useEffect, useState } from 'react'
import { Button, Divider, message } from 'antd'
import { useTranslation } from 'react-i18next'

const PageTypes = ({
  activeType: propActiveType,
  onClickType,
  pageStructureData,
  currentPage,
  pageTypes = {}
}) => {
  const [activeType, setActiveType] = useState()

  const { t } = useTranslation()

  useEffect(() => {
    setActiveType(propActiveType)
  }, [propActiveType])

  const handleClick = type => {
    const isCurrentType = activeType === type
    const newType = isCurrentType ? null : type

    const currentPageData = pageStructureData[currentPage - 1]

    const pageHasScenario =
      currentPageData &&
      currentPageData.data.some(node => node.type === 'SCENARIO')

    if (pageHasScenario) {
      message.error(t('v5:you_cannot_add_other_element_in_a_scenario_page'), 10)
      return
    }

    setActiveType(newType)

    if (onClickType) {
      onClickType(newType)
    }
  }

  useEffect(() => {
    if (activeType) {
      const notSelectable =
        activeType === 'bulletPoints' ||
        activeType === 'introduction' ||
        activeType === 'summary'

      if (notSelectable) return

      let type = activeType
      if (activeType === 'worldScenario') {
        type = 'Real World Scenario'
      }
      if (activeType === 'matchImage') {
        type = 'Match Image'
      }
      message.info(
        `${t('v5:pages_list_whose_content_you_want_to_reference')} ${type}.`
      )
    }
  }, [activeType])

  return (
    <Fragment>
      <div className="type-options">
        {Object.keys(pageTypes).map(type => (
          <Button
            key={type}
            className="type-option"
            type={activeType === type ? 'primary' : 'default'}
            onClick={() => handleClick(type)}
          >
            {pageTypes[type]}
          </Button>
        ))}
      </div>
    </Fragment>
  )
}

export default PageTypes
